import { FINANCE, LEASING, SALES, VerticalType } from '@rma/generic/domain/types';
import { SocialMediaEventType } from './enum/social-media-event-type';

export type CuratedSocialSharePostType = 'review' | 'listing' | 'award';

export function getCuratedSocialSharePostType(eventType: SocialMediaEventType): CuratedSocialSharePostType | undefined {
  switch (eventType) {
    case SocialMediaEventType.MortgageBrokerReview:
    case SocialMediaEventType.LeasingReview:
    case SocialMediaEventType.Review:
      return 'review';
    case SocialMediaEventType.Listing:
    case SocialMediaEventType.Transaction:
    case SocialMediaEventType.LeasingListing:
    case SocialMediaEventType.LeasingTransaction:
      return 'listing';
    case SocialMediaEventType.Award:
      return 'award';
    default:
      return undefined;
  }
}

export function getVerticalTypeFromEventType(eventType: SocialMediaEventType): VerticalType {
  switch (eventType) {
    case SocialMediaEventType.MortgageBrokerReview:
      return FINANCE;
    case SocialMediaEventType.LeasingReview:
    case SocialMediaEventType.LeasingListing:
    case SocialMediaEventType.LeasingTransaction:
      return LEASING;
    default:
      return SALES;
  }
}

export function getReviewEventType(verticalType: VerticalType): SocialMediaEventType {
  switch (verticalType) {
    case FINANCE:
      return SocialMediaEventType.MortgageBrokerReview;
    case LEASING:
      return SocialMediaEventType.LeasingReview;
    default:
      return SocialMediaEventType.Review;
  }
}

export function getListingEventType(verticalType: VerticalType, isActive = true): SocialMediaEventType {
  if (verticalType === LEASING) {
    return isActive ? SocialMediaEventType.LeasingListing : SocialMediaEventType.LeasingTransaction;
  }
  return isActive ? SocialMediaEventType.Listing : SocialMediaEventType.Transaction;
}
